
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/user/space",
      function () {
        return require("private-next-pages/terms/user/space.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/user/space"])
      });
    }
  